import api from '../lib/api';
import { toArray } from '../lib/utils';
import type {
  SubscriptionPlan,
  UserSubscription,
  Payment,
  PaymentDetailsResponse,
} from '../types/subscription';

class SubscriptionService {
  async getPlans(affiliateCode?: string): Promise<SubscriptionPlan[]> {
    const params = affiliateCode ? { affiliate_code: affiliateCode } : undefined;
    const response = await api.get('/subscriptions/plans', { params });
    return toArray(response.data);
  }

  async getUserSubscription(): Promise<UserSubscription | null> {
    const response = await api.get('/subscriptions/users');
    return response.data[0] || null;
  }

  async getPayments(): Promise<Payment[]> {
    const response = await api.get('/subscriptions/payments');
    return response.data.data || [];
  }

  async getPaymentDetails(paymentId: number): Promise<PaymentDetailsResponse> {
    const response = await api.get(`/subscriptions/payments/${paymentId}`);
    return response.data;
  }

  async cancelSubscription(subscriptionId: number): Promise<void> {
    await api.post(`/subscriptions/users/${subscriptionId}/cancel`);
  }

  async reactivateSubscription(subscriptionId: number): Promise<void> {
    await api.post(`/subscriptions/users/${subscriptionId}/reactivate`);
  }

  async changePlan(subscriptionId: number, planId: number): Promise<void> {
    await api.put(`/subscriptions/users/${subscriptionId}`, {
      plan_id: planId,
    });
  }

  async createSubscription(
    planId: number,
    isTrialPeriod: boolean = false,
    affiliateCode?: string
  ): Promise<any> {
    const data: any = {
      plan_id: planId,
      is_trial: isTrialPeriod,
    };

    if (affiliateCode) {
      data.affiliate_code = affiliateCode;
    }

    const response = await api.post('/subscriptions/users', data);
    return response.data;
  }
}

export default new SubscriptionService();
